import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

  *, *:before, *:after {
    box-sizing: border-box;
  }

  body {
    font-size: ${(props) => props.theme.font.size.fontSize02};
    position: relative;
  }

  body,
  html {
    background-color: ${(props) => props.theme.color.white};
    font-family: ${(props) => props.theme.font.family};
    line-height: ${(props) => props.theme.layout.sizeSpacing05};
  }

  body > *,
  html > * {
    flex-shrink: 0;
  }

  h1 {
    font-weight: ${(props) => props.theme.font.weight.medium};
    font-size: ${(props) => props.theme.font.size.fontSize08};
    line-height: ${(props) => props.theme.layout.sizeSpacing07};
    margin: 0 0 ${(props) => props.theme.layout.sizeSpacing02};
    color: ${(props) => props.theme.color.grey600};
  }

  h3, h4, h5, h6, p {
    color: ${(props) => props.theme.color.grey400};
  }

  strong {
    font-weight: bold;
  }
  
  // styles override needed until versions of @justgiving/styles are fixed
  .jg-video-input__input {
    font-size: ${({ theme }) => theme.font.size.fontSize02};
  }

  .jg-colour-picker + .jg-text--link {
    font-weight: ${(props) => props.theme.font.weight.regular};
    font-size: ${(props) => props.theme.font.size.fontSize01};
  }

  a, .jg-text--link {
    font-weight: 400;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .font-bold {
    font-weight: 500;
  }

  .text-dark {
    color: var(--color-text-dark)
  }

  strong.cp-body-medium {
    font-weight: 500;
  }

  .h-full-vh {
    height: calc(100vh - 60px);
    height: calc(100dvh - 60px - env(safe-area-inset-bottom)); 
  }

  .h-full {
    height: 100%;
  }

  .layoutContainer {
    min-height: 472px;
    height: 100%;
    overflow: auto;
  }
`;
